const state = {
  currentProduct: { id: '', name: '' },
  /** 包含退房日顯示：1=包含（退房日+1、晚），0=不包含（最後住宿日、天）；缺省視為 1 */
  showCheckoutDate: 1,
}

const getters = {
  currentProduct: (state) => state.currentProduct,
  productId: (state) => state.currentProduct.id,
  productName: (state) => state.currentProduct.name,
  showCheckoutDate: (state) => state.showCheckoutDate,
}

const mutations = {
  SET_PRODUCT_ID(state, id) {
    state.currentProduct.id = id
  },
  SET_PRODUCT_NAME(state, name) {
    state.currentProduct.name = name
  },
  SET_PRODUCT(state, product) {
    state.currentProduct = product
  },
  SET_SHOW_CHECKOUT_DATE(state, value) {
    if (value === 0 || value === '0' || value === false) {
      state.showCheckoutDate = 0
      return
    }
    if (value == null || value === '') {
      state.showCheckoutDate = 1
      return
    }
    state.showCheckoutDate = Number(value) === 1 ? 1 : 0
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
